import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

import ChangeImpactFormContainer from '../../../containers/projects/ChangeImpactFormContainer.jsx';

const EditChangeImpact = ({ projectId, changeImpactId, slug }) => (
  <>
    <Helmet>
      <title>Edit Change Impact | ChangeSync</title>
    </Helmet>

    <ChangeImpactFormContainer
      projectId={projectId}
      changeImpactId={changeImpactId}
      slug={slug}
    />
  </>
);

EditChangeImpact.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
  changeImpactId: Number(query.changeImpactId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(EditChangeImpact));
